module.exports = "header, footer {\r\n  padding-top: 15px;\r\n  padding-bottom: 15px;\r\n}\r\n\r\nbody {\r\n  margin-top: 100px;\r\n  margin-bottom: 100px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/visbos-touch-client/visbos-touch-client.component.css
// module id = ./src/app/visbos-touch-client/visbos-touch-client.component.css
// module chunks = main